export const LOGON_PAGE = {
  INTERFACE_ID: "zwSZb26C48kIGMIy",
  ON_CLICK_CHANGE_YOUR_PASSWORD: "J1ROWO6C48kIGKS9",
  LOAD: "CzA9b26C48kIGDIp",
  ON_LOGIN: "B12I726C48kIGB36",
  ON_PASSWORD_TOGGLE: "RAn.5R6C48kIGBcv",
  ON_INPUT_CHANGE: {
    username: "Iybw726C48kIGB1u",
    password: "6Sqw726C48kIGByi"
  }
};
export const LOGON_FOOTER = {
  ON_CLICK_PRIVACY_POLICY: "nEA25R6C48kIGKGw",
  ON_CLICK_TERMS_OF_USE: "FKh25R6C48kIGKJB",
  LOAD: "zxjW5R6C48kIGKFs"
};
export const UPDATE_PASSWORD_PAGE = {
  INTERFACE_ID: "IE.K2O6C48kIGM8c",
  ON_CANCEL: "H_Bm2O6C48kIGNKr",
  ON_SAVE_NEW_PASSWORD: "6vTm2O6C48kIGNLs",
  ON_CONTINUE: "bLLZgp6C48kIGHrK",
  ON_PASSWORD_TOGGLE: "rA9Tgp6C48kIGIvB",
  ON_CONFIRM_NEW_PASSWORD_TOGGLE: "9Bnzgp6C48kIGIz.",
  ON_NEW_PASSWORD_TOGGLE: "Tb2zgp6C48kIGIx_",
  LOAD: "Xtyq2O6C48kIGM.r",
  ON_INPUT_CHANGE: {
    password: "4AaG2O6C48kIGNID",
    newPassword: "9k9G2O6C48kIGNJB",
    newPasswordConfirmation: "TdIm2O6C48kIGNJ."
  }
};
export const RESET_PASSWORD_PAGE = {
  INTERFACE_ID: "ifuXWO6C48kIGKvU",
  ON_CANCEL: "f44PWO6C48kIGKzg",
  ON_NEXT: "1pPvWO6C48kIGLC7",
  LOAD: "Pcj3WO6C48kIGKyg",
  ON_INPUT_CHANGE: {
    username: "jgka2O6C48kIGNAy"
  }
};
export const EMAIL_SENT_PAGE = {
  INTERFACE_ID: "_cNk2O6C48kIGMtf",
  LOAD: "l5YS2O6C48kIGM2m",
  ON_DONE: "acky2O6C48kIGM5Z"
};
export const SET_NEW_PASSWORD_PAGE = {
  INTERFACE_ID: "Dmmj.O6C48kIGFQn",
  ON_SAVE_NEW_PASSWORD: "CLan.O6C48kIGGEu",
  ON_CONFIRM_NEW_PASSWORD_TOGGLE: "FkWkOp6C48kIGF1Z",
  ON_NEW_PASSWORD_TOGGLE: "2MskOp6C48kIGFzx",
  LOAD: "dplT.O6C48kIGFg0",
  ON_INPUT_CHANGE: {
    newPassword: "9eKH.O6C48kIGGBQ",
    newPasswordConfirmation: "lBKH.O6C48kIGGBg"
  }
};
export const PASSWORD_CHANGE_SUCCESS_PAGE = {
  INTERFACE_ID: "J0AsOp6C48kIGN5X",
  LOAD: "mSKcOp6C48kIGOBS",
  ON_CLICK_DONE: "OiKcOp6C48kIGOBF"
};